import { createInertiaApp } from "@inertiajs/react";
import { createElement } from "react";
import { createRoot } from "react-dom/client";

// Layouts
import AdminLayout from "./layouts/AdminLayout.jsx";

// Pages — consumer
import OffersIndex from "./pages/Offers/Index.jsx";
import OffersShow from "./pages/Offers/Show.jsx";
import QueuesIndex from "./pages/Queues/Index.jsx";
import QueuesShow from "./pages/Queues/Show.jsx";
import MenuShow from "./pages/Menu/Show.jsx";
import CartShow from "./pages/Cart/Show.jsx";
import CheckoutShow from "./pages/Checkout/Show.jsx";
import WalletShow from "./pages/Wallet/Show.jsx";
import OrdersShow from "./pages/Orders/Show.jsx";

// Pages — admin
import AdminQueueMonitor from "./pages/Admin/QueueMonitor.jsx";
import AdminQueueMonitorDetail from "./pages/Admin/QueueMonitorDetail.jsx";
import AdminQueueHistory from "./pages/Admin/QueueHistory.jsx";
import AdminQueueHistoryDetail from "./pages/Admin/QueueHistoryDetail.jsx";
import AdminUsers from "./pages/Admin/Users.jsx";
import AdminMenus from "./pages/Admin/Menus.jsx";
import AdminScheduleMonitor from "./pages/Admin/ScheduleMonitor.jsx";
import GuestMySchedule from "./pages/Guest/MySchedule.jsx";
import AdminNetworkMonitor from "./pages/Admin/NetworkMonitor.jsx";

// Pages — JourneyQueue Map Monitor
import AdminQueueMapMonitor from "./pages/Admin/QueueMapMonitor/Index.jsx";

// Pages — AR Node (SensePoint) CRUD management
import AdminArNodesIndex from "./pages/Admin/ArNodes/Index.jsx";

// Pages — cloudTraQ GDS Ops Command Center
import AdminCloudtraqGdsIndex from "./pages/Admin/CloudtraqGds/Index.jsx";
import AdminCloudtraqGdsSkillFeed from "./pages/Admin/CloudtraqGds/SkillFeed.jsx";
import AdminCloudtraqGdsChannelSensorOps from "./pages/Admin/CloudtraqGds/ChannelSensorOps.jsx";
import AdminCloudtraqGdsNodeHeatMap from "./pages/Admin/CloudtraqGds/NodeHeatMap.jsx";
import AdminCloudtraqGdsHighRisk from "./pages/Admin/CloudtraqGds/HighRisk.jsx";
import AdminCloudtraqGdsDispatchBoard from "./pages/Admin/CloudtraqGds/DispatchBoard.jsx";
import AdminCloudtraqGdsPnrMutations from "./pages/Admin/CloudtraqGds/PnrMutations.jsx";
import AdminCloudtraqGdsMasterPnr from "./pages/Admin/CloudtraqGds/MasterPnr.jsx";
import AdminCloudtraqGdsAncRevenue from "./pages/Admin/CloudtraqGds/AncRevenue.jsx";
import AdminCloudtraqGdsCarrierMetrics from "./pages/Admin/CloudtraqGds/CarrierMetrics.jsx";
import AdminCloudtraqGdsPnrDetail from "./pages/Admin/CloudtraqGds/PnrDetail.jsx";
import AdminCloudtraqGdsThirdPartyPanel from "./pages/Admin/CloudtraqGds/ThirdPartyPanel.jsx";

const pages = {
  // Consumer
  "Offers/Index": OffersIndex,
  "Offers/Show": OffersShow,
  "Queues/Index": QueuesIndex,
  "Queues/Show": QueuesShow,
  "Menu/Show": MenuShow,
  "Cart/Show": CartShow,
  "Checkout/Show": CheckoutShow,
  "Wallet/Show": WalletShow,
  "Orders/Show": OrdersShow,
  // Admin
  "Admin/QueueMonitor": AdminQueueMonitor,
  "Admin/QueueMonitorDetail": AdminQueueMonitorDetail,
  "Admin/QueueHistory": AdminQueueHistory,
  "Admin/QueueHistoryDetail": AdminQueueHistoryDetail,
  "Admin/Users": AdminUsers,
  "Admin/Menus": AdminMenus,
  "Admin/ScheduleMonitor": AdminScheduleMonitor,
  "Guest/MySchedule": GuestMySchedule,
  "Admin/NetworkMonitor": AdminNetworkMonitor,
  // JourneyQueue Map Monitor
  "Admin/QueueMapMonitor/Index": AdminQueueMapMonitor,
  "Admin/ArNodes/Index":         AdminArNodesIndex,
  // cloudTraQ GDS Ops Command Center
  "Admin/CloudtraqGds/Index": AdminCloudtraqGdsIndex,
  "Admin/CloudtraqGds/SkillFeed": AdminCloudtraqGdsSkillFeed,
  "Admin/CloudtraqGds/ChannelSensorOps": AdminCloudtraqGdsChannelSensorOps,
  "Admin/CloudtraqGds/NodeHeatMap": AdminCloudtraqGdsNodeHeatMap,
  "Admin/CloudtraqGds/HighRisk": AdminCloudtraqGdsHighRisk,
  "Admin/CloudtraqGds/DispatchBoard": AdminCloudtraqGdsDispatchBoard,
  "Admin/CloudtraqGds/PnrMutations": AdminCloudtraqGdsPnrMutations,
  "Admin/CloudtraqGds/MasterPnr": AdminCloudtraqGdsMasterPnr,
  "Admin/CloudtraqGds/AncRevenue": AdminCloudtraqGdsAncRevenue,
  "Admin/CloudtraqGds/CarrierMetrics": AdminCloudtraqGdsCarrierMetrics,
  "Admin/CloudtraqGds/PnrDetail": AdminCloudtraqGdsPnrDetail,
  "Admin/CloudtraqGds/ThirdPartyPanel": AdminCloudtraqGdsThirdPartyPanel,
};

document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("app");

  if (el) {
    createInertiaApp({
      // Auto-apply AdminLayout to every Admin/* page (persistent across Inertia navigations).
      // Individual pages can opt out by setting MyPage.layout = null,
      // or override with MyPage.layout = (page) => <OtherLayout>{page}</OtherLayout>.
      resolve: (name) => {
        const page = pages[name];
        if (name.startsWith("Admin/") && page && page.layout === undefined) {
          page.layout = (children) =>
            createElement(AdminLayout, null, children);
        }
        return page;
      },
      setup({ el, App, props }) {
        createRoot(el).render(createElement(App, props));
      },
    });
  }
});
